<mat-card class="card-size  element" [ngClass]="{'disabled-card':disabled}">
  <mat-card-content>

    @if (element!=null) {
    <div class="text-container">
      <mat-card-title style="max-width: calc(100% - 40px);word-break: break-word;">{{ element.name }}
      </mat-card-title>
      <mat-card-subtitle>{{ element.notes }}</mat-card-subtitle>
      <div class="button-card-sovrapossition">
        <ng-content select="[button]">
        </ng-content>
      </div>
    </div>
    <div class="flex-between-center w100 flex-direction-row">
      <div class="flex-start-center w100 flex-direction-row" style="width: calc(100% - 42px)">
        <div class="flex-start-center w100 flex-direction-row">
          @if (element.environment) {
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'elementParse.environment'|translate }}</div>
            <div>{{ getFotometriaValue(element, 'environment')|traductionNotTraduction|async }}</div>
          </div>
          }
          @if (element.floor!=null) {
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'elementParse.floor'|translate }}</div>
            <div>{{ getFotometriaValue(element, 'floor')|traductionNotTraduction|async }}</div>
          </div>
          }
          @if (element.room) {
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'elementParse.room'|translate }}</div>
            <div>{{ getFotometriaValue(element, 'room')|traductionNotTraduction|async }}</div>
          </div>
          }
        </div>
        <div class="flex-start-center w100 flex-direction-row">
          @if (element.createdAt) {
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'createdAt'|translate }}</div>
            <div>{{ getFotometriaValue(element, 'createdAt')|customDate:'medium'|async }}</div>
          </div>
          }
          @if (element.updatedAt) {
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'updatedAt'|translate }}</div>
            <div>{{ getFotometriaValue(element, 'updatedAt')|customDate:'medium'|async }}</div>
          </div>
          }
          @if (element.type) {
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'elementParse.type'|translate }}</div>
            <div>{{ getFotometriaValue(element, 'type') }}</div>
          </div>
          }
        </div>
        <div class="flex-start-center w100 flex-direction-row">
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'elementParse.calculateCounter'|translate }}</div>
            <div>{{ element.calculateCounterTraduction()|translate }}</div>
          </div>
          @if (element.tags|transformValueByPredicateFunction:joinArray;as tagsJoined) {
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'elementParse.tags'|translate }}</div>
            <div>{{ tagsJoined }}</div>
          </div>
          }

          @if (element.lastCounterUpdate) {
          <div class="flex-start-start flex-direction-column text-container">
            <div class="text-child">{{ 'elementParse.lastCounterUpdate'|translate }}</div>
            <div>{{ element.lastCounterUpdate|customDate:'medium'|async }}</div>
          </div>
          }
          @if (element.parentElement) {
          <div class="flex-start-start flex-direction-column text-container w100">
            <div class="flex-between-center flex-direction-row">
              <div class="text-child">{{ 'elementParse.parentElement'|translate }}</div>
              <button (click)="clickParent()" mat-icon-button class="parentElement">
                <mat-icon svgIcon="parent"></mat-icon>
              </button>
            </div>
            <div>{{ getFotometriaValue(element, 'parentElement') }}</div>
          </div>
          }
        </div>
      </div>
      <div style="width: 42px" class="flex-direction-column">
        <ng-content select="[bottom]">
        </ng-content>
      </div>
    </div>
    }
  </mat-card-content>
</mat-card>